import * as React from 'react'
import * as TestySDK from 'sdk/testy-web-sdk'
import * as SWR from 'hooks/swr'
import * as T from 'components/ui/typography'

import OutlinedBox from 'components/shared/outlined-box'
import WorkspaceItems from './items'
import CAvatar from 'components/shared/avatar'

import { getFromStorage } from 'utils/local-storage'
import { UserContext } from 'providers//context/user-context'
import { analytics } from 'utils/analytics'
import { Select, SelectContent } from 'components/ui/select'
import { SelectTrigger } from '@radix-ui/react-select'
import { AuthContext } from 'providers/auth-provider'

export interface WorkspaceButtonProps {
    workspace?: string
    selectWorkspace: (user: string, workspace: string) => void
    workspaceList?: GetUserWorkspacesForAppResponse[]
}

const WorkspaceButton = () => {
    const { authData } = React.useContext(AuthContext)

    const [actualWorkspace, setActualWorkspace] = React.useState<string>()
    const { data: userWorkspaceData, mutate: infoMutate } = SWR.useWorkspace(actualWorkspace || '')
    const { data: userWorkspacesInfoData, mutate: userWorkspacesInfoMutate } = SWR.useGetUserWorspacesForApp()
    const { userData, chooseWorkspace } = React.useContext(UserContext)

    React.useEffect(() => {
        const savedWorkspace = getFromStorage('savedWorkspace')
        if (savedWorkspace !== null) setActualWorkspace(savedWorkspace)
        else setActualWorkspace(userData?.appWorkspace)
    }, [userData?.appWorkspace])

    const selectWorkspace = React.useCallback(
        (workspaceId: string) => {
            if (authData?.userUid && chooseWorkspace) {
                TestySDK.createUserWorkspace(authData.userUid, workspaceId)
                setActualWorkspace(workspaceId)
                chooseWorkspace(workspaceId)
                analytics.track('changed_workspace', { newWorkspace: userWorkspaceData?.name })
                userWorkspacesInfoMutate()
                infoMutate()
            }
        },
        [chooseWorkspace, infoMutate, userWorkspaceData?.name, userWorkspacesInfoMutate, authData?.userUid],
    )

    const RenderWorkspace = React.useCallback(() => {
        return (
            <WorkspaceItems
                selectWorkspace={selectWorkspace}
                workspace={actualWorkspace}
                workspaceList={userWorkspacesInfoData}
            />
        )
    }, [actualWorkspace, selectWorkspace, userWorkspacesInfoData])

    return (
        <Select value={actualWorkspace} onValueChange={(value: string) => selectWorkspace(value)}>
            <SelectTrigger>
                <OutlinedBox className="flex items-center !rounded-sm p-2 max-w-[200px] cursor-pointer overflow-hidden">
                    <CAvatar src={userWorkspaceData?.logo_url} fallback="WS" className="h-6 w-6 mr-1" />
                    <T.Small className="max-w-[420px] text-sm font-bold overflow-hidden font-[Manrope] whitespace-nowrap text-ellipsis">
                        {userWorkspaceData?.name || 'Workspace'}
                    </T.Small>
                </OutlinedBox>
            </SelectTrigger>
            <SelectContent className=" mt-2">{RenderWorkspace()}</SelectContent>
        </Select>
    )
}

export default WorkspaceButton
